import { Component, OnInit } from "@angular/core";
import { UsersService } from "./users.service";
import { AccountsService } from "../accounts/accounts.service";
import { Router } from "@angular/router";

@Component({
  selector: "create-user",
  template: require('./createuser.component.html'),
  styles: [require('./createuser.component.scss')]
})
export class CreateUserComponent implements OnInit {
  users: any[] = [
    {
      active: false,
      name: "",
      email: ""
    }
  ];
  sent: boolean = false;
  activePanels: string[] = ["details"];
  submitted: boolean = false;
  projects: any[] = [];
  accountProjects: any[] = [];
  account: any;

  constructor(private service: UsersService, private router: Router) {}

  ngOnInit() {
    this.account = AccountsService.currentAccount;
    if (!this.account) {
      this.router.navigate(["/accounts"]);
    } else {
      this.getProjects();
    }
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = projects;
      this.accountProjects = this.projects.filter((it) => {
        return AccountsService.currentAccount.project_ids.indexOf(it.id) > -1;
      });
    });
  }

  isValid() {
    return this.users[0].name && this.users[0].email;
  }

  back() {
    window.history.back();
  }

  onSubmit() {
    this.activePanels = [];
    if (!this.sent) {
      this.sent = true;
      this.service
        .createUser(this.users[0], AccountsService.currentAccount.id)
        .subscribe(
          (res) => {
            this.back();
          },
          (error) => {
            this.sent = false;
            setTimeout(() => {
              this.activePanels = ["details"];
            }, 1);
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/users/createuser.component.ts